import { IQualityLevelInfoSchema } from 'shared/repositories/offer-card/entities/agent/QualityLevelInfoSchema';

import { IState } from '../../store';

export const selectSuperAgentLevelInfo = (state: IState): IQualityLevelInfoSchema | undefined | null => {
  return state.offerData.agent?.moderationInfo?.qualityLevelInfo;
};
